import { render } from "./TopicBreakdown.vue?vue&type=template&id=506a5ef8&scoped=true"
import script from "./TopicBreakdown.vue?vue&type=script&lang=js"
export * from "./TopicBreakdown.vue?vue&type=script&lang=js"

import "./TopicBreakdown.vue?vue&type=style&index=0&id=506a5ef8&scoped=true&lang=css"

import exportComponent from "/Users/sophiasharif/Desktop/projects/i-hate-pinia/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-506a5ef8"]])

export default __exports__